import { type FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { IconComponent } from '@/components/IconComponent';
import { useTournament } from '@/modules/tournaments/hooks';
import { ScTournamentLimits } from './styled';

interface ITournamentLimits {
  minBet?: string;
  minSpins?: string;
  name: string;
}

export const TournamentLimits: FC<ITournamentLimits> = memo(
  ({ minBet, minSpins, name }) => {
    const { t } = useTranslation('tournaments');
    const { displayAmount } = useTournament(name, minBet);

    return (
      <ScTournamentLimits>
        <div className="limit">
          <IconComponent name="betIcon" size="20px" />
          <span>
            {displayAmount}{' '}
            {t(`common:tournaments.${minBet ? 'minBet' : 'minBetEmpty'}`)}
          </span>
        </div>
        {minSpins && (
          <div className="limit">
            <IconComponent name="spinsIcon" size="20px" />
            <span>
              {minSpins} {t('common:tournaments.minSpins')}
            </span>
          </div>
        )}
      </ScTournamentLimits>
    );
  }
);
